export default {
  survey: 'Fragebogen',
  'survey.start': 'Fragebogen ausfüllen',
  'survey.finish': 'Abschließen',

  'survey.notification.completed': 'Fragebogen abgeschlossen',

  'survey.facility-requested-survey':
    'Bitte beantworten Sie ein paar Fragen, bevor Sie mit der Terminbuchung fortfahren.',
  'survey.error': 'Es ist ein Fehler aufgetreten',
  'survey.error.description':
    'Das ausgewählte Formular kann zur Zeit nicht ausgefüllt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',

  'question.address.city': 'Stadt',
  'question.address.house-number': 'Hausnummer',
  'question.address.zipcode': 'PLZ',
  'question.address.street': 'Straße',

  'question.email': 'Email',

  'question.document.upload.title': 'Datei hochladen',

  'question.document.upload.download': 'Herunterladen',
  'question.document.upload.upload': 'Hochladen',

  'question.document.upload.description': 'Hier klicken oder Datei hereinziehen',
  'question.document.upload.description.complete': 'Datei hochgeladen und bestätigt',
  'question.document.upload.confirm-save':
    'Bitte überprüfen Sie das hochgeladene Dokument. Dieses kann nach Bestätigung nicht mehr geändert werden.',
  'question.document.upload-success': 'Datei {fileName} erfolgreich hochgeladen',
  'question.document.download-document': 'Datei herunterladen',
  'question.document.login-required': 'Anmeldung erforderlich',
  'question.document.login-required.description':
    'Zur weiteren Bearbeitung des Fragebogens ist die Erstellung eines Benutzerkontos notwendig.',

  'question.document.max-file-size-exceeded':
    'Datei {fileName} zu groß. Maximale Dateigröße: {maxFileSize} MB',
  'question.document.upload-error': 'Fehler beim Hochladen der Datei {fileName}',
  'question.document.upload-error.virus-found':
    'Diese Datei konnte nicht hochgeladen werden, da sie die Sicherheitsprüfung nicht bestanden hat.',
  'question.document.file-deleted': 'Datei {fileName} wurde gelöscht',

  'form.data-privacy-consent-missing.title': 'Datenschutzerklärung noch nicht akzeptiert',
  'form.data-privacy-consent-missing.description':
    'Um mit der Terminanfrage fortzufahren, muss die {privacyLink} akzeptiert werden.',
  'form.data-privacy-consent-missing.accept': 'Akzeptieren',

  'form.error': 'Es ist ein Fehler aufgetreten',
};
